"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerRefinance = void 0;
const constants_1 = require("../../../../constants");
const helpers_1 = require("../../../../helpers");
const types_1 = require("../../../../types");
const offer_1 = require("../../offer");
const anchor_1 = require("@project-serum/anchor");
const borrowerRefinance = ({ programId, connection, accounts, args, optimistic, addComputeUnits, priorityFees, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const bondTradeTransactionV2Seed = Math.ceil(Math.random() * 1000000);
    const mockBondOffer = new anchor_1.web3.PublicKey('AzCWVy3S2NCW5HVKUuxsbf8Cw5jAYuh3pE3hjAUgKhPL');
    const [bondTradeTransactionV2, bondTradeTransactionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.BOND_TRADE_TRANSACTOIN_PREFIX),
        accounts.userPubkey.toBuffer(),
        constants_1.ENCODER.encode(bondTradeTransactionV2Seed.toString()),
    ], program.programId);
    const [sponsorVault, sponsorVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.PERPETUAL_SPONSOR_VAULT)], program.programId);
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: priorityFees });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [bondOfferVault, bondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.bondOffer.toBuffer()], program.programId);
    const [oldBondOfferVault, oldBondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.oldBondOffer.toBuffer()], program.programId);
    instructions.push(yield program.methods
        .borrowerRefinance(new anchor_1.BN(args.solToRefinance), new anchor_1.BN(bondTradeTransactionV2Seed), new anchor_1.BN(args.aprRate))
        .accountsStrict({
        oldBondTradeTransaction: accounts.previousBondTradeTransaction,
        fbond: accounts.fbond,
        bondOfferV2: accounts.bondOffer,
        bondTradeTransaction: bondTradeTransactionV2,
        user: accounts.userPubkey,
        protocolFeeReceiver: accounts.protocolFeeReceiver,
        hadoMarket: accounts.hadoMarket,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        mutualBondTradeTxnVault,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        lender: accounts.previousLender,
        uninitializedOldBondOfferV2: accounts.oldBondOffer,
        sponsorVault: sponsorVault,
        bondOfferVault: bondOfferVault,
        oldBondOfferVault: oldBondOfferVault,
    })
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    const inputFee = accounts.userPubkey == constants_1.NEW_PERPETUAL_DEV ? true : false;
    const optimisticResult = (0, offer_1.optimisticBorrowPerpetual)({
        fraktBond: optimistic.fraktBond,
        bondTradeTransaction: bondTradeTransactionV2.toBase58(),
        bondOffer: optimistic.bondOffer,
        userPubkey: accounts.userPubkey.toBase58(),
        amountOfSolToGet: args.solToRefinance,
        minMarketFee: args.aprRate,
        inputFee,
        isRefinance: true,
        isBorrower: true,
        optimizeIntoReserves: true,
        redeemResult: types_1.RedeemResult.Reborrow,
        borrowerOriginalLent: 0,
        borrowerFullRepaidAmount: 0
    });
    const fullLoanBody = optimistic.oldBondTradeTransaction.solAmount + optimistic.oldBondTradeTransaction.feeAmount;
    const solInterest = (0, offer_1.calculateCurrentInterestSolPure)({
        loanValue: fullLoanBody,
        startTime: optimistic.oldBondTradeTransaction.soldAt,
        currentTime: (0, offer_1.nowInSeconds)(),
        rateBasePoints: optimistic.oldBondTradeTransaction.amountOfBonds,
    });
    const updatedOldBondOffer = optimistic.oldBondOffer
        ? (0, offer_1.optimisticRepayUpdateBondingBondOffer)(optimistic.oldBondOffer, fullLoanBody, solInterest, false, optimistic.oldBondTradeTransaction.bondTradeTransactionState !==
            types_1.BondTradeTransactionV2State.PerpetualManualTerminating)
        : optimistic.oldBondOffer;
    const updatedOldBondTradeTransaction = (0, offer_1.optimisticRepayBondTradeTransaction)(optimistic.oldBondTradeTransaction, true, types_1.RedeemResult.Reborrow, (0, offer_1.getRepaymentDestination)((_a = optimistic.oldBondOffer) === null || _a === void 0 ? void 0 : _a.pairState, optimistic.oldBondTradeTransaction.bondTradeTransactionState
        != types_1.BondTradeTransactionV2State.PerpetualManualTerminating));
    const upfront_fee = optimisticResult.fraktBond.fbondTokenSupply || optimistic.oldBondTradeTransaction.feeAmount;
    return {
        instructions,
        signers,
        optimisticResult: {
            bondOffer: optimisticResult.bondOffer,
            fraktBond: Object.assign(Object.assign({}, optimisticResult.fraktBond), { borrowedAmount: args.solToRefinance - upfront_fee }),
            newBondTradeTransaction: optimisticResult.bondTradeTransaction,
            oldBondTradeTransaction: updatedOldBondTradeTransaction,
            oldBondOffer: updatedOldBondOffer,
        },
    };
});
exports.borrowerRefinance = borrowerRefinance;
